const mapBy = <T>(array: T[], key: keyof T) => array.map(item => item[key]);

export { mapBy };
